import { ChangeDetectorRef, Component, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { Events } from 'ionic-angular';
import { componentHolderService } from '../../providers/component-holder.service/component-holder.service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
@Component({
  selector: 'main-component-holder',
  templateUrl: 'main-component-holder.html'
})
export class MainComponentHolderComponent {
  @ViewChild('mainComponentHolder', { read: ViewContainerRef, static: false }) mainComponentHolder: ViewContainerRef;

  text: string;
  sourcekey: any = [];
  gridDataRows: any = [];
  girdDataAccessType: any;
  gridTemplateProperty: any;
  templateName: any;
  gridParam: any;
  screen: string;
  components: any;
  componentRef: any;
  broadcastSubs: any;

  constructor(public driveService: DriveServiceProvider, public communicationServ: CommunicationServiceProvider, private cdr: ChangeDetectorRef, private componentFactoryResolver: ComponentFactoryResolver, private configApiService: ConfigApiServiceProvider, private componentService: componentHolderService, public events: Events) {

    /* * * * * * * * *
    * Get app components from component holder service
    * * * * * * * * */
    this.initDriveEvents()
  }

  /* * * * *
   * components array to get component
   * * * * * */
  getComponent(name) {
    for (let i = 0; i < this.components.length; i++) {
      let item = this.components[i];
      if (item.compName === name) {

        return item;
      }
    };
    return null;
  }

  initDriveEvents() {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "defaultProps") {
          if (data.event === 'pullAppComponents') {
            let flag = data['status'];
            if (flag) {
              this.driveService.broadcastInfo({ src: 'comp-main', event: 'getAppComponents', status: true, components: this.components });
            }
          }
        }
        if (data.src === "compLoad") {
          if (data.event === 'triggerComponentLoad') {
            let dataAccessType = data['status'];
            let templateProperty = data['item'];
            let param = data['param'];
            let allrows = data["allrows"];
            let isShare = data['isShare']
            if (allrows) {
              this.gridDataRows = allrows;
            }
            this.girdDataAccessType = dataAccessType;
            this.gridTemplateProperty = templateProperty;
            this.templateName = templateProperty[0].templateName;
            this.gridParam = param;
            this.sourcekey = this.gridTemplateProperty[0]["sourceKey"];
            this.loadHolderComponent(this.girdDataAccessType, this.gridTemplateProperty, this.gridParam, this.gridDataRows, this.templateName, this.sourcekey,isShare);
          }
        }
      })

  }

  ngOnInit() {
    if (window.innerWidth > 700) {
      this.screen = "Web";
    } else {
      this.screen = "Mobile";
    }
    this.components = this.componentService.getComponents();
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  /* * * * *
  * render holder component
  * * * * * */
  loadHolderComponent(girdDataAccessType, gridTemplateProperty, gridParam, gridDataRows, templateName, sourcekey,isShare) {

    let component: any = '';
    let componentHolderName: any = '';
    let tracker_Id: any = '';
    let objEnableTrack: any = '';
    objEnableTrack = this.driveService.objCurrentFolder['objEnableTrack'];

    if (objEnableTrack) {
      objEnableTrack = JSON.parse(objEnableTrack);
      componentHolderName = objEnableTrack['componentHolderName'];
      tracker_Id = objEnableTrack['tracker_Id'];

    }
    if (componentHolderName) {
      component = this.getComponent(componentHolderName);
      if (!component) {
        component = this.getComponent('default-Holder');
      }
    } else {
      component = this.getComponent('default-Holder');

    }
    if (component) {
      if (this.mainComponentHolder != undefined) {
        this.mainComponentHolder.clear();
      }
      let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
      this.componentRef = this.mainComponentHolder.createComponent(componentFactory);
      this.componentRef.instance.girdDataAccessType = girdDataAccessType;
      this.componentRef.instance.gridTemplateProperty = gridTemplateProperty;
      this.componentRef.instance.gridParam = gridParam;
      this.componentRef.instance.gridDataRows = gridDataRows;
      this.componentRef.instance.sourcekey = sourcekey;
      this.componentRef.instance.templateName = templateName;
      this.componentRef.instance.tracker_Id = tracker_Id;
      this.componentRef.instance.components = this.components;
      this.componentRef.instance.isShare = isShare;
    }
    // this.cdr.detectChanges();
  }
  ngAfterViewChecked(){
    this.cdr.detectChanges();
    }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/components/main-component-holder/main-component-holder.ts